<i class="dl-splitter__greep fa-solid"
   [class.fa-arrows-left-right]="schermindeling.richting() === 'hori'"
   [class.fa-arrows-up-down]="schermindeling.richting() === 'verti'"
   [title]="'DRAGTORESIZE' | translate"></i>
